import React from "react"
import HtmlParser from "react-html-parser"
import MaterialProviderItem from "./material-provider-item"
import { generateRandomString } from "../../helpers/keys"

export default function MaterialProviderComponent({ heading, partnerShowcases }) {
  const description = HtmlParser(heading)

  const htmlMaterialProviderItems =
    !!partnerShowcases && partnerShowcases.length > 0
      ? partnerShowcases.map((item) => {
          return <MaterialProviderItem key={generateRandomString()} material={item.material} label={item.label} />
        })
      : null

  return (
    <section className="material-provider-container">
      <div className="w--narrow">
        <div className="rich-text">{description}</div>
        {htmlMaterialProviderItems}
      </div>
    </section>
  )
}
